import { inject } from '@angular/core';
import { CollaborationScreenService } from '@libs/collaboration';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface MyCollaborationsSidebarState {
  filterDirectOnly: boolean;
  filterUnreadOnly: boolean;
  filterTeamCollab: boolean;
  filterClinicalCollab: boolean;
}

const initialState: MyCollaborationsSidebarState = {
  filterUnreadOnly: false,
  filterDirectOnly: false,
  filterTeamCollab: false,
  filterClinicalCollab: false,
};

interface UpdateFiltersParams {
  directOnly: boolean;
  unreadOnly: boolean;
  teamCollab: boolean;
  clinicalCollab: boolean;
}

export const MyCollaborationsSidebarStore = signalStore(
  withState(initialState),
  withMethods((store) => {
    const collabScreenService = inject(CollaborationScreenService);

    return {
      updateFilters: ({ directOnly, unreadOnly, teamCollab, clinicalCollab }: UpdateFiltersParams): void => {
        const directOnlyChanged = directOnly !== store.filterDirectOnly();
        const unreadOnlyChanged = unreadOnly !== store.filterUnreadOnly();
        const teamCollabChanged = teamCollab !== store.filterTeamCollab();
        const clinicalCollabChanged = clinicalCollab !== store.filterClinicalCollab();

        if (!directOnlyChanged && !unreadOnlyChanged && !teamCollabChanged && !clinicalCollabChanged) {
          return;
        }

        patchState(store, {
          filterDirectOnly: directOnly,
          filterUnreadOnly: unreadOnly,
          filterTeamCollab: teamCollab,
          filterClinicalCollab: clinicalCollab,
        });

        collabScreenService.updateFilters({
          filters: { directOnly, unreadOnly, teamCollab, clinicalCollab },
          clearCollabs: false,
          fetchCollabs: true,
        });
      },
    };
  }),
);
